<!-- ======================= Page Body ========================== -->
<div class="container page-top-gap">
  <div class="row">
    <div class="col-lg-12">
      <div class="card page-body">

        <!-- ================ Form ================ -->

          <div>

              <!-- ================ Your Selected Card ================ -->

              <h2 class="heading-5" i18n="@@cardrecommendationTitle">Based on your initial input, below Card(s) are suitable for you.</h2>
              <hr />
              <div class="row section-top m-b-30" *ngIf="this.recommendedCards.length>0">

                  <!--  --------- Card Box --------- -->
                  <div class="col-lg-4 col-md-6 item-top-gap" *ngFor="let card of recommendedCards">
                      <div class="card-box card-gap-mobile">
                          <div class="m-b-15 card-size-small"><img src="{{card.SelectionImage}}" alt="{{card.Name}}" /></div>
                          <div class="body-card-info">
                              <div class="body-2 m-b-15 box-card-name">{{card.Name}}</div>
                              <div class="wr-height-cardbody">
                                  <div _ngcontent-c5="" class="box-card-info" [innerHTML]="card.ShortDescription">
                                  </div>

                              </div>
                          </div>
                          <hr />
                          <div>
                              <button [ngClass]="{'btn':true, 'btn-secondary': card.Id!=this.sharingDataService.minimumPaymtCalSharedData.SelectedCard?.Id, 'btn-selected': card.Id==this.sharingDataService.minimumPaymtCalSharedData.SelectedCard?.Id}"
                                      class="btn btn-secondary" id="{{card.Id}}" (click)="selectClickHandler(card)" i18n="@@Select">
                                  Select
                              </button>
                          </div>

                      </div>
                  </div>
                  <!--  --------- /Card Box --------- -->
                  <!-- ================ Button Bar ================ -->

                  <hr class="m-t-40">
                  <div class="layout-container btn-footer full-page m-auto ieonly-btn-footer">
                      <div class="layout-col">
                          <button *ngIf="this.sharingDataService.minimumPaymtCalSharedData.SelectedCard"
                                  class="btn btn-primary btn-next pos-relative" type="button"
                                  (click)="proceedClickHandler()">
                              <span i18n="@@GenericProceedBtn">GenericProceedBtn</span>
                            </button>
                      </div>
                  </div>

                  <!-- ================ /Button Bar ================ -->

              </div>

              <div class="section-top m-b-30">
                  <div class="text-feedback" *ngIf="this.recommendedCards?.length==0 && this.isSuccess == true;">
                      <h3 class="heading-3" i18n="@@NoCardAvaliable">No card is avaliable for you.</h3>
                  </div>
              </div>

              <div class="section-top m-b-30">
                  <div class="text-feedback" *ngIf="this.isSuccess == false;">
                      <h3 class="heading-3">{{errorMessage}}</h3>
                  </div>
              </div>

              <!-- ================ /Form ================ -->

          </div>
      </div>
    </div>
  </div>
  <!-- ======================= /Page Body ========================== -->